module.exports = __webpack_public_path__ + "static/img/marketing-email.811e5e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/marketing/marketing-email.png
// module id = 4aOr
// module chunks = 2